<template>
    <p class="mt-1 text-sm text-tertiary">
        <slot />
    </p>
</template>
